import React from 'react';

/** When the component mounted. Use it in render instead of `new Date()`, which changes on every render. */
export function useNow(): Date {
    const [now] = React.useState(() => new Date());
    return now;
}
